import { jsx } from 'react/jsx-runtime';
import '../Box/index.js';
import { Spinner } from '../Spinner/index.js';
import { Button } from './Button.js';
import { Flex } from '../Box/BoxSystem.js';

const LoadMoreButton = ({ loading, onClick, }) => (jsx(Flex, Object.assign({ mt: 4, justifyContent: "center" }, { children: jsx(Button, Object.assign({ size: "40", disabled: loading, width: "100px", onClick: onClick, variant: "secondary" }, { children: loading ? jsx(Spinner.Flex, { primary: true }) : 'Load More' })) })));

export { LoadMoreButton };
